/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RecipesInputs */

const en_nav_recipes = /** @type {(inputs: Nav_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipes`)
};

const de_nav_recipes = /** @type {(inputs: Nav_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepte`)
};

/**
* | output |
* | --- |
* | "Recipes" |
*
* @param {Nav_RecipesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_recipes = /** @type {((inputs?: Nav_RecipesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RecipesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_recipes(inputs)
	return en_nav_recipes(inputs)
});